import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Table from "../../../components/table/Table";
import DateInput from "../../../components/inputs/DateInput";
import { Component } from "react-image-crop";
import SwalServices from "../../../services/swalServices/SwalServices";
import CPASMemberServices from "../../../services/axiosServices/apiServices/CPASMemberServices";
import { encryptAES } from "../../../utils/Encryption";
import { useNavigate } from "react-router-dom";
import { WebPath } from "../../../utils/AppSetting";
import DropdownSelect from "../../../components/dropdown/Dropdown";
export default class CPDClaimApproval extends Component {
  constructor(props) {
    super(props);

    this.swaServices = new SwalServices();
    this.CPASMemberServices = new CPASMemberServices();
    this.state = {
      //    totalResultes: 0,
      pagination: {
        pageNo: 1,
        pageSize: 10,
        orderByColumn: "",
        orderFlag: 0,
        searchText: "",
        activityTypeId: 0,
        cpdstatusId: 0,
      },
      isLoading: false,
      cPDClaimApprovalList: [],
      applicationTierList: [],
      cPDStatusList: [],
    };
  }

  GetAllDropDownsForCPASMember = () => {
    this.CPASMemberServices.GetAllDropDownsForCPASMember().then((response) => {
      if (response.statusCode === 200 && response.responseItem != null) {
        let TierList = response.responseItem.responseContent.filter(
          (drp) => drp.dropdownName === "ActivityType"
        );
        TierList.map(function (item) {
          delete item["dropdownName"];
          return item;
        });
        this.setState({ applicationTierList: TierList });

        let StatusList = response.responseItem.responseContent.filter(
          (drp) => drp.dropdownName === "CPDStatus"
        );
        StatusList.map(function (item) {
          delete item["dropdownName"];
          return item;
        });
        this.setState({ cPDStatusList: StatusList });
      }
    });
    this.getAllCPDClaimApprovalList();
  };

  componentDidMount() {
    this.GetAllDropDownsForCPASMember();
  }

  getAllCPDClaimApprovalList = (pagination = this.state.pagination) => {
    this.setState({ isLoading: false });
    this.CPASMemberServices.getAllCPDClaimApprovalList(pagination).then(
      (response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          this.setState({
            cPDClaimApprovalList:
              response.responseItem.responseContent.itemList,
          });
          this.setState({
            totalResultes: response.responseItem.responseContent.totalCount,
          });

          console.log(
            "responseContent.itemList",
            this.state.cPDClaimApprovalList
          );
        }
      }
    );
  };
  setPagination = (newPagination) => {
    this.setState({ pagination: newPagination });
    this.getAllCPDClaimApprovalList(newPagination);
  };

  handleView = (aCPActivityId) => {
    if (aCPActivityId) {
      // window.location.href =
      //   "CPDEditClaimApproval?aCPActivityId=" +
      //   encryptAES(aCPActivityId);
      window.location.href =
        "/CPDEditClaimApproval/aCPActivityId?=" + encryptAES(aCPActivityId);
    }
  };

  actions = (element, index, row) => {
    if (element !== "aCPActivityId") return null;

    return (
      <td className="px-2 first:pl-5 text-center border-[#ffffff] last:pr-5 whitespace-nowrap w-[15%] tble-td-txt text-[#000000]">
        <a
          href="#"
          className="text-blue-600 underline"
          onClick={() => this.handleView(row)}
        >
          View
        </a>
      </td>
    );
  };

  setTierFilter = (id) => {
    let detail = this.state.pagination;
    detail.pageNo = 1;
    detail.activityTypeId = id;
    this.setState({ pagination: { ...detail } }, () => {
      this.getAllCPDClaimApprovalList();
    });
  };

  setStatusFilter = (id) => {
    let detail = this.state.pagination;
    detail.pageNo = 1;
    detail.cpdstatusId = id;
    this.setState({ pagination: { ...detail } }, () => {
      this.getAllCPDClaimApprovalList();
    });
  };

  searchByText = (value) => {
    let detail = this.state.pagination;
    detail.pageNo = 1;
    detail.pageSize = 10;
    detail.searchText = value;
    this.setState({ pagination: { ...detail } }, () => {
      this.getAllCPDClaimApprovalList();
    });
  };

  searchByName = (value, identity) => {
    let detail = this.state.pagination;
    if (identity === "acpName") {
      detail.pageNo = 1;
      detail.pageSize = 10;
      detail.acpName = value;
      this.setState({ pagination: { ...detail } });
    }
    this.getAllCPDClaimApprovalList();
  };

  render() {
    return (
      <div className="main-body-section">
        <main className="pb-10">
          <div className="custom-card shadow-lg mb-10 bg-white">
            <div className="filter-info grid grid-cols-12 gap-6">
              <div className="filter-types 2xl:col-span-4 2xl:order-2 lg:order-2 order-2 lg:col-span-6 col-span-12">
                <h2 className="input-title mb-3">
                  Search by Activity
                </h2>
                <DropdownSelect
                  drpIdentity={"ActivityType"}
                  optionArray={this.state.applicationTierList}
                  setFilterParameters={this.setTierFilter.bind(this)}
                  value={this.state.pagination.activityTypeId}
                />
              </div>
              <div className="filter-types 2xl:col-span-4 2xl:order-2 lg:order-2 order-2 lg:col-span-6 col-span-12">
                <h2 className="input-title mb-3">
                  Search by status
                </h2>
                <DropdownSelect
                  drpIdentity={"CPDStatus"}
                  optionArray={this.state.cPDStatusList}
                  setFilterParameters={this.setStatusFilter.bind(this)}
                  value={this.state.pagination.cpdstatusId}
                />
              </div>
              <div className="filter-types 2xl:col-span-4 2xl:order-2 lg:order-2 order-2 lg:col-span-6 col-span-12">
                <h2 className="input-title mb-3">
                  Search by Certificate Number/Name/Email
                </h2>
                <input
                  id="default"
                  className="form-input rounded-none w-full shadow-red py-3 text-lg"
                  type="text"
                  placeholder="Search by Certification Number/Name/Email"
                  onChange={(e) =>
                    this.searchByText(e.target.value, "searchText")
                  }
                />
              </div>

              <div className="grid grid-flow-col md:col-span-3 lg:order-4 order-3 sm:auto-cols-max justify-end items-center sm:justify-start gap-3 mt-4 ml-0">
                <button
                  className="btn btn-blue text-white px-14"
                  onClick={() => this.searchByCPD()}
                >
                  <span className="text-xl text-white font-semibold tracking-normal">
                    Search
                  </span>
                </button>

                {/* <a href={`${WebPath}CpdSubmissionForm`} target="_blank">
                  <button className="btn btn-blue text-white px-14">
                    <span className="text-xl text-white font-semibold tracking-normal">
                      Create
                    </span>
                  </button>
                </a> */}
              </div>
            </div>
          </div>

          <div className="relative">
            <div>
              <div className="cpd-claim-approval-table">
                <Table
                  columns={[
                    {
                      name: "certificateNumber",
                      title: "CPD Certification Number",
                    },
                    { name: "acpName", title: "Name" },
                    { name: "course", title: "Course" },
                    { name: "cpdpoints", title: "CPD Points" },
                    { name: "approvedPoints", title: "Approved Points" },
                    { name: "cpdStatusName", title: "Status" },
                    { name: "aCPActivityId", title: "Action" },
                  ]}
                  rows={this.state.cPDClaimApprovalList}
                  isLoading={this.state.isLoading}
                  sortingColumns={["companyName", "statusName"]}
                  pagination={this.state.pagination}
                  totalResults={this.state.totalResultes}
                  totalCount={this.state.totalResultes}
                  setPagination={this.setPagination}
                  customScope={[
                    {
                      column: "aCPActivityId",
                      renderTableData: this.actions.bind(this),
                    },
                  ]}
                />
              </div>
            </div>
          </div>
        </main>
      </div>
    );
  }
}
